import { Dropdown, Modal, Col, Row, Space, Typography, message } from "antd";
import CollaboratorsView from "../components/CollaboratorsView";
import { useState } from "react";
import CollaboratorView from "../components/CollaboratorView";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getCollaboratorsExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { Collaborator } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function CollaboratorsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [collaboratorInputMode, setCollaboratorInputMode] = useState<
    "add" | "view" | "delete"
  >("add");
  const [collaboratorInputUid, setCollaboratorInputUid] = useState<
    string | null | undefined
  >({} as any);
  const [collaboratorInputOpen, setCollaboratorInputOpen] = useState(false);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const [collaboratorInputValues, setCollaboratorInputValues] =
    useState<Collaborator>({} as any);
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onCollaboratorAction(
    mode: "add" | "view" | "delete",
    values?: Collaborator,
  ): void {
    setCollaboratorInputMode(mode);
    setCollaboratorInputOpen(true);
    setCollaboratorInputUid(values?.uid);
  }

  function onCollaboratorFinish(): void {
    setCollaboratorInputOpen(false);
    setCollaboratorInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onCollaboratorClose(): void {
    setCollaboratorInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading Collaborators export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getCollaboratorsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Collaborators
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("PlatformCollaborators", "create")}

            className={`${!permissions.can("PlatformCollaborators", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("PlatformCollaborators", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onCollaboratorAction("add")}
          >
            Add Collaborator
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <CollaboratorsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onCollaboratorAction(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <CollaboratorView
        open={collaboratorInputOpen}
        mode={collaboratorInputMode}
        uid={collaboratorInputUid!}
        initialValues={collaboratorInputValues}
        onFinish={onCollaboratorFinish}
        onClose={onCollaboratorClose}
      />
      {contextHolder}
    </Col>
  );
}

export default CollaboratorsPage;
